module.exports = __webpack_public_path__ + "static/img/FI.c610c65e.jpg";